import { useState, useEffect } from 'react'
import Navbar from '../components/Navbar/Navbar'
import Hero from '../components/Hero/Hero'
import PackagesPreview from '../components/PackagesPreview/PackagesPreview'
import Services from '../components/Services/Services'
import Portfolio from '../components/Portfolio/Portfolio'
import Footer from '../components/Footer/Footer'
import PreviewModal from '../components/PreviewModal/PreviewModal'

const Home = () => {
  const [previewModal, setPreviewModal] = useState<{ isOpen: boolean; url: string; title: string }>({
    isOpen: false,
    url: '',
    title: ''
  })

  useEffect(() => {
    // Scroll progress indicator
    const progressBar = document.createElement('div')
    progressBar.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      height: 3px;
      background: #ffffff;
      z-index: 9999;
      transform-origin: left;
      width: 0%;
      transition: width 0.1s ease;
    `
    document.body.appendChild(progressBar)

    const handleScroll = () => {
      const windowHeight = document.documentElement.scrollHeight - window.innerHeight
      const scrolled = (window.pageYOffset / windowHeight) * 100
      progressBar.style.width = `${scrolled}%`
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
      document.body.removeChild(progressBar)
    }
  }, [])

  const handlePreviewOpen = (url: string, title: string) => {
    setPreviewModal({ isOpen: true, url, title })
  }

  const handlePreviewClose = () => {
    setPreviewModal({ isOpen: false, url: '', title: '' })
  }

  return (
    <>
      <Navbar />
      <Hero />
      <PackagesPreview />
      <Services />
      <Portfolio onPreviewOpen={handlePreviewOpen} />
      <Footer />
      <PreviewModal
        isOpen={previewModal.isOpen}
        url={previewModal.url}
        title={previewModal.title}
        onClose={handlePreviewClose}
      />
    </>
  )
}

export default Home
